<template>
  <div class="slide-transition">
    <transition name="content" mode="in-out" appear>
      <div class="content" :key="$route.params.project">
        <slot></slot>
      </div>
    </transition>
    <transition v-if="rows <= 1" name="overlay" mode="in-out" appear>
        <div class="overlay" :style="{'background-color': color}" :key="$route.params.project"></div>
    </transition>
    <transition  v-else name="overlay" mode="in-out" appear>
      <div :key="$route.params.project" class="overlay-rows">
          <div :style="{'background-color': color, 'height' : `${lineHeight - 4}px`}" v-for="(i, index) in rows" :key="index"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SlideTransition',
  props: {
    color: {
      type: String,
      default: '#000000'
    },
    lineHeight: {
      type: Number,
      required: true
    },
    rows: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="scss">
.slide-transition {
  width: 100%;
  height: 100%;
  position: relative;
  .content, .overlay, .overlay-rows {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .content {
    background: var(--white);
    overflow: hidden;
    z-index: 100;
  }

  .overlay {
    z-index: 110;
  }

  .overlay-rows {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 110;
    transform: scaleX(0);
    overflow: hidden;
    & > div {
      margin: 4px 0 0 0;
      transform-origin: 0% 50%;
      &:nth-child(1) {
        // transform: scaleX(0.9);
      }
      &:nth-child(2) {
        // transform: scaleX(0.9);
      }
      &:nth-child(3) {
        transform: scaleX(0.8);
      }
    }
  }



  /**
  * Image
  */

  .overlay-enter-active{
    animation: overlay-transition .9s var(--easing) forwards;
  }
  @keyframes overlay-transition {
    0%{
      transform: scaleX(0);
      transform-origin: 0% 50%;
    }
    49.99%{
      transform-origin: 0% 50%;
    }
    50%{
      transform: scaleX(1);
    }
    50.01%{
      transform-origin: 100% 50%;
    }
    100%{
      transform-origin: 100% 50%;    
      transform: scaleX(0)
    }
  }

  .content-enter-active{
    transition: width .5s var(--easing);
    z-index: 10;
  }
  .content-enter {
    width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SlideTransition.vue